function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Children, cloneElement, forwardRef } from 'react';
import { string, bool, arrayOf, node, oneOfType } from 'prop-types';
import { designTokenPropTypes } from '@immediate_media/design-tokens';
import cn from 'clsx';
import ListItem from '../../atoms/ListItem/index.jsx';

/**
 * List component.
 */
const List = /*#__PURE__*/forwardRef(({
  className,
  children,
  itemSpacingX,
  itemSpacingY,
  ordered,
  horizontal,
  usePadding,
  marginTop,
  gtmLabel,
  ...restProps
}, ref) => {
  const TagName = ordered ? 'ol' : 'ul';
  const childList = Children.toArray(children).filter(child => child);
  const spacingType = usePadding ? 'p' : 'm';
  const spacingTop = `${spacingType}t-${itemSpacingY}`;
  const spacingBottom = `${spacingType}${marginTop && !usePadding ? 't' : 'b'}-${itemSpacingY}`;
  const spacingRight = `${spacingType}r-${itemSpacingX}`;
  return /*#__PURE__*/React.createElement(TagName, _extends({}, restProps, {
    className: cn(className, 'list', horizontal && 'list--horizontal'),
    "data-gtm-class": gtmLabel,
    ref: ref
  }), childList.map((child, index) => /*#__PURE__*/cloneElement(child, {
    className: cn(child.props.className, itemSpacingY && `${spacingBottom}` + (!horizontal ? ` ${spacingTop}` : ""), itemSpacingX && horizontal && childList.length - 1 > index && `${spacingRight}`)
  })));
});
List.displayName = 'List';
List.defaultProps = {
  className: '',
  children: [],
  itemSpacingX: null,
  itemSpacingY: null,
  ordered: false,
  horizontal: false,
  usePadding: false,
  marginTop: false,
  gtmLabel: null
};
List.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional classes to be added to the root of the component. */
  className: string,
  /** The children to be rendered as list items. */
  children: oneOfType([arrayOf(node), node]),
  /** The horizontal spacing between each item. */
  itemSpacingX: designTokenPropTypes.spacingUnit,
  /** The vertical spacing between each item. */
  itemSpacingY: designTokenPropTypes.spacingUnit,
  /** Render as an ordered list (using the <ol> tag). */
  ordered: bool,
  /** Render the list horizontally. */
  horizontal: bool,
  /** Use padding, instead of margins, between list items. */
  usePadding: bool,
  /** Should the margin be added to the top or the bottom of the element */
  marginTop: bool,
  /** A label to be used for GTM tracking. */
  gtmLabel: string
} : {};
List.Item = ListItem;
export default List;